import React from "react";
import { FormattedMessage } from "react-intl";
import { MoveNavigation 
        ,Center
       } from '../../theme/globalStyle'
import { ImageFacebook, ImageTwitter, ImageTumblr, ImageInstagram, ImagePinterest, ImageReddit, ImageSlidShare, ImageTelegram, ImageGitlab, ImageYoutube, ImageArchive, ImageMedium } from './';

const SocialMedia = props => (
    <Center>
        <b><i><FormattedMessage id="presents-in-social-media" /></i></b>
        <MoveNavigation>
            <li>
                <a href="https://www.facebook.com/yhwhesmisalvacion" target="_blank" rel="noopener noreferrer" aria-label="Go to Facebook"><ImageFacebook /></a>
            </li>
            <li>
                <a href="https://twitter.com/yhwhsalvacion" target="_blank" rel="noopener noreferrer" aria-label="Go to Twitter"><ImageTwitter /></a>
            </li>
            <li>
                <a href="https://yhwhesmisalvacion.tumblr.com/" target="_blank" rel="noopener noreferrer" aria-label="Go to Tumblr"><ImageTumblr /></a>
            </li>
            <li>
                <a href="https://www.instagram.com/yhesmisalvacion/" target="_blank" rel="noopener noreferrer" aria-label="Go to Instagram"><ImageInstagram /></a>
            </li>
            <li>
                <a href="https://www.pinterest.com/yhwhesmisalvacion/" target="_blank" rel="noopener noreferrer" aria-label="Go to Pinterest"><ImagePinterest /></a>
            </li>
            <li>
                <a href="https://www.reddit.com/user/yhwhesmisalvacion" target="_blank" rel="noopener noreferrer" aria-label="Go to Reddit"><ImageReddit /></a>
            </li>
            <li>
                <a href="https://www.slideshare.net/yhwhesmisalvacion" target="_blank" rel="noopener noreferrer" aria-label="Go to SlideShare"><ImageSlidShare /></a>
            </li>
            <li>
                <a href="https://t.me/yhwhesmisalvacion" target="_blank" rel="noopener noreferrer" aria-label="Go to Telegram"><ImageTelegram /></a>
            </li>
            <li>
                <a href="https://gitlab.com/yhwhesmisalvacion" target="_blank" rel="noopener noreferrer" aria-label="Go to Gitlab"><ImageGitlab /></a>
            </li>
            <li>
                <a href="https://www.youtube.com/channel/UC_P8nP2DLM5gQ7rUT3k4yZQ" target="_blank" rel="noopener noreferrer" aria-label="Go to Youtube"><ImageYoutube /></a>
            </li>
            <li>
                <a href="https://archive.org/details/@yhwh_es_mi_salvaci_n" target="_blank" rel="noopener noreferrer" aria-label="Go to Archive"><ImageArchive /></a>
            </li>
            <li>
                <a href="https://medium.com/@yhwhesmisalvacion" target="_blank" rel="noopener noreferrer" aria-label="Go to Medium"><ImageMedium /></a>
            </li>
        </MoveNavigation>
    </Center>
)

export default SocialMedia